import Card from "@pathwright/ui/src/components/card/Card"
import useCohortPermissions from "@pathwright/web/src/modules/cohort/useCohortPermissions"
import GroupAccessCard from "group/components/manage/access/GroupAccessCard"
import GroupArchiveCard from "group/components/manage/archive/GroupArchiveCard"
import GroupCommerceCard from "group/components/manage/commerce/GroupCommerceCard"
import GroupDetailsCard from "group/components/manage/details/GroupDetailsCard"
import GroupFeaturesCard from "group/components/manage/features/GroupFeaturesCard"
import { createCardRoutes } from "lib/core/routing/card-routing"
import { getDefaultLaunchedFromHome } from "lib/core/routing/utils"
import path from "path-browserify"
import { useEffect } from "react"
import { cohortFeaturesCardRoutes } from "./features-routes"

// redirects user to /home/ if user does not have permissions to manage cohort
const PermissionsRedirectContainer = (props) => {
  const { hasEditorLevelAccess } = useCohortPermissions({
    cohortId: parseInt(props.params.cohortId)
  })

  useEffect(() => {
    if (hasEditorLevelAccess === false) {
      App.getStore("navigation").action.goHome()
    }
  }, [hasEditorLevelAccess])

  // HACK: rendering Card because null causes an error in CardStack
  // TODO: fix error
  if (!hasEditorLevelAccess) return <Card card={props.card} />
  return props.children
}

export const groupCardRoutes = {
  path: ":resourceId(\\d+)/:cohortId(\\d+)/",
  component: ({ match, card }) => (
    <PermissionsRedirectContainer {...{ params: match.params, card }}>
      <GroupDetailsCard
        card={card}
        resourceId={parseInt(match.params.resourceId)}
      />
    </PermissionsRedirectContainer>
  ),
  middleware: ({ match, location }, replace) => {
    window.App.getStore("groupAdmin")
      .action.loadGroup(match.params.resourceId, match.params.cohortId)
      .promise.then((group) => {
        // Prevent accessing the archive card for child Cohorts as we don't allow directly
        // archiving child Cohorts, only via archiving the parent (Collection) Cohort.
        if (
          group.get("parent_offering_id") &&
          location.pathname.includes("/archive/")
        ) {
          return replace(path.join(location.pathname, "../"))
        }
      })
  },
  getDefaultLaunchedFrom: getDefaultLaunchedFromHome,
  childCards: {
    features: {
      component: GroupFeaturesCard
    },
    access: {
      component: GroupAccessCard
    },
    commerce: {
      component: GroupCommerceCard
    },
    archive: {
      component: GroupArchiveCard
    },
    ...cohortFeaturesCardRoutes
  }
}

export default createCardRoutes(
  "/manage/group/",
  { group: groupCardRoutes },
  require("home/components/HomeOrLibraryBrowse").default
)
